import React from 'react'

import { ZariContext } from '_zari/context'

import { Form, Col, Modal, Button, Row, Divider } from '_zari/core'

import { DateHandler, RounderUtil } from 'utils'

import * as FormGroups from './formGroups'
import * as Sections from './sections'

const AsignacionCuotasModal = ({ handleClose, show, submitData, submitFunction }) => {
  const __zariContext = React.useContext(ZariContext)

  const montoTotal = submitData.importeTotal
  const [cantidadCuotas, setCantidadCuotas] = React.useState(
    submitData.cantidadCuotas ? `${submitData.cantidadCuotas}` : '1'
  )
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [mostrarTabla, setMostrarTabla] = React.useState(!!submitData.cuotas)

  const cuotasRef = React.useRef(submitData.cuotas || [])
  const infoUnicaCuotaRef = React.useRef(null)

  const clickContinuar = React.useCallback(() => {
    if (!cantidadCuotas) {
      __zariContext.snack('error', 'Ingresar cantidad de cuotas.')
      return
    }

    if (parseFloat(cantidadCuotas) === 1 && !submitData.cuotas) {
      const fechaEmisionDate = DateHandler.parse(submitData.fechaEmision)
      const fechaCuota = DateHandler.add(fechaEmisionDate, { days: 30 })
      const fechaCuotaStr = DateHandler.format(fechaCuota)

      const nuevoObjeto = {
        orden: 1,
        plazoDias: 30,
        fecha: fechaCuotaStr,
        monto: montoTotal
      }

      infoUnicaCuotaRef.current = nuevoObjeto
      cuotasRef.current = [nuevoObjeto]
    }

    setMostrarTabla(true)
  }, [cantidadCuotas, __zariContext, submitData, montoTotal])

  const clickGuardar = React.useCallback(() => {
    setIsSubmitting(true)

    if (!cantidadCuotas) {
      __zariContext.snack('error', 'Ingresar cantidad de cuotas.')
      setIsSubmitting(false)
      return
    }

    const intCantidadCuotas = parseInt(cantidadCuotas)
    const cuotas = cuotasRef.current
    const cantidadCuotasArray = cuotas.length

    if (intCantidadCuotas === 0 || cantidadCuotasArray === 0) {
      __zariContext.snack('error', 'Ingresar cuotas.')
      setIsSubmitting(false)
      return
    }

    if (intCantidadCuotas !== cantidadCuotasArray) {
      __zariContext.snack('error', 'La cantidad de cuotas ingresadas no coincide con la cantidad indicada.')
      setIsSubmitting(false)
      return
    }

    const cuotasNormalizadas = cuotas.map(x => ({
      orden: x.orden,
      plazoDias: parseFloat(x.plazoDias),
      fecha: x.fecha,
      monto: parseFloat(x.monto)
    }))

    let sumaPagos = 0
    for (let i = 0; i < cuotasNormalizadas.length; i++) {
      sumaPagos = RounderUtil.round(sumaPagos + cuotasNormalizadas[i].monto)
    }

    if (sumaPagos !== montoTotal) {
      __zariContext.snack('error', 'La suma de cuotas no coincide con el monto total.')
      setIsSubmitting(false)
      return
    }

    submitFunction(
      {
        ...submitData,
        cantidadCuotas: intCantidadCuotas,
        cuotas: cuotasNormalizadas
      },
      { setSubmitting: setIsSubmitting }
    )
  }, [__zariContext, submitData, submitFunction, cantidadCuotas, montoTotal])

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>CUOTAS DE PAGO</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Divider title='Cuotas' />
        <Row>
          <Col md={4}>
            <FormGroups.ImporteTotalFormGroup value={montoTotal} />
          </Col>
          <Col md={4}>
            <FormGroups.CantidadCuotasFormGroup
              onChange={e => setCantidadCuotas(e.target.value)}
              value={cantidadCuotas}
              fIsSubmitting={isSubmitting}
            />
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label text='.' md={12} alignRightAt='md' />
              <Col md={12}>
                <Button onClick={clickContinuar} tiny outline>
                  Continuar
                </Button>
              </Col>
            </Form.Group>
          </Col>
        </Row>
        {mostrarTabla && (
          <Sections.TablaSection
            cuotasRef={cuotasRef}
            cantidadCuotas={cantidadCuotas ? parseFloat(cantidadCuotas) : 0}
            edicionCuotasData={submitData.cuotas || []}
            infoUnicaCuota={infoUnicaCuotaRef.current}
            fechaEmisionDocumento={submitData.fechaEmision}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose} disabled={isSubmitting}>
          Cancelar
        </Button>
        <Button id='boton-guardar-cuotas' onClick={clickGuardar} disabled={isSubmitting}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(AsignacionCuotasModal)
